import request from '@/utils/request'

export function getGameList (data) {
  return request({
    url: '/gameList',
    method: 'post',
    data
  })
}

export function getGameDetail (id) {
  return request({
    url: '/gameDetail',
    method: 'post',
    data: {
      id: id
    }
  })
}

export function getEventDetail (id) {
  console.log(4332)
  return request({
    url: '/eventDetail',
    method: 'post',
    data: {
      id: id
    }
  })
}

export function getSubjectList (param) {
  return request({
    url: '/subjectList',
    method: 'get',
    param
  })
}

export function getcateList (param) {
  return request({
    url: '/cateList',
    method: 'get',
    param
  })
}

export function getHomeList (param) {
  return request({
    url: '/homeList',
    method: 'get',
    param
  })
}

export function getHomeIndex (param) {
  return request({
    url: '/homeIndex',
    method: 'get',
    param
  })
}

export function getGuideDetail (id) {
  return request({
    url: '/guideDetail',
    method: 'post',
    data: {
      id: id
    }
  })
}

export function getArticleDetail (id) {
  return request({
    url: '/articleDetail',
    method: 'post',
    data: {
      id: id
    }
  })
}
